const goalsMap = {
  hair: [
    {
      name: 'Tame frizz',
      dataKey: 'anti-frizz',
      image:
        'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Tame_Frizz.svg?v=1730820668'
    },
    {
      name: 'Hydrate',
      dataKey: 'hydrate',
      image:
        'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/Hydration.svg?v=1734092840'
    },
    {
      name: 'Length',
      dataKey: 'lengthen',
      image:
        'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Lengthen.svg?v=1730820668'
    },
    {
      name: 'Deep condition',
      dataKey: 'deep-condition',
      image:
        'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Deep_Hydration.svg?v=1730820668'
    },
    {
      name: 'Fix split ends',
      dataKey: 'fix-split-ends',
      image:
        'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/fix_split_ends.svg?v=1733950390'
    },
    {
      name: 'Scalp care',
      dataKey: 'soothe-scalp',
      image:
        'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Deep_Hydration.svg?v=1730820668'
    },
    {
      name: 'Volumize',
      dataKey: 'volumize',
      image:
        'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Volumize.svg?v=1730820668'
    },
    {
      name: 'Define curls',
      dataKey: 'curl-definition',
      image:
        'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/define-curls.svg?v=1734035627'
    },
    {
      name: 'Nourish',
      dataKey: 'nourish-roots',
      image:
        'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Nourish_Scalp.svg?v=1730820668'
    },
    {
      name: 'Anti-Breakage',
      dataKey: 'anti-breakage',
      image:
        'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/anti-breakage_4ad0f44e-74dd-45f3-8141-d1a55e082a3f.svg?v=1734035627'
    },
    {
      name: 'Replenish',
      dataKey: 'replenish-hair',
      image:
        'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/replenish.svg?v=1733950604'
    },
    {
      name: 'Amplify shine',
      dataKey: 'shine',
      image:
        'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Amplify_Shine.svg?v=1730820668'
    },
    {
      name: 'Straighten',
      dataKey: 'straighten',
      image:
        'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Anti-breakage.svg?v=1730820668'
    },
    {
      name: 'Strengthen',
      dataKey: 'strengthen',
      image:
        'https://cdn.shopify.com/s/files/1/0690/8139/9608/files/Strengthen.svg?v=1730820668'
    }
  ]
};

const discontinuedGoalsMap = {
  hair: [
    {
      name: 'Preserve color',
      dataKey: 'color-protection'
    },
    {
      name: 'Protect from heat',
      dataKey: 'thermal-protection'
    },
    {
      name: 'Revitalize',
      dataKey: 'anti-aging'
    }
  ]
};

const mapGoalStringToLabels = (goalsString) => {
  const goals = goalsString.split(',');
  const goalNames = goals.map(
    (goal) =>
      goalsMap.hair.find(
        ({ dataKey }) =>
          dataKey.replace('-', ' ').toLowerCase() ===
          goal.replace('-', ' ').toLowerCase()
      )?.name || goal
  );
  return goalNames.join(', ');
};

const goalsAsLabelValue = goalsMap.hair.map((goal) => {
  return {
    label: goal.name,
    value: goal.dataKey
  };
});

const discontinuedGoalsAsValue = discontinuedGoalsMap.hair.map((goal) => {
  return goal.dataKey;
});

const parseGoalsFromHtmlElement = (selector) => {
  const goalElements = document.querySelectorAll(selector);
  goalElements?.forEach((goalElement) => {
    const goals = mapGoalStringToLabels(goalElement.textContent);
    goalElement.textContent = goals;
  });
};

export {
  goalsMap,
  discontinuedGoalsMap,
  mapGoalStringToLabels,
  goalsAsLabelValue,
  discontinuedGoalsAsValue,
  parseGoalsFromHtmlElement
};
